<template>
    <aside :class="['sidebar', { open }]">
        <ul>
            <li v-for="(item, index) in items" :key="index"
                     @click.stop="changeRoute(item.route)"
                     v-if="checkVisible(item.admin) && typeof (item.children) == 'undefined' && hasPermission(item.section)"
                     :class="{ 'selected-item': isSelected(item.route) }">

                <i aria-hidden="true" class="v-icon material-icons theme--light">{{ item.icon }}</i>

                <span class="nav-label">
                    {{ item.text }}
                    <span v-if="item.section === 'Debug' && debugFailedCount > 0" class="debug-count-badge">({{ debugFailedCount }} errori - 2 mesi)</span>
                </span>
            </li>
        </ul>
    </aside>
</template>

<script>

import { mapGetters } from 'vuex'
import globalFunctions from '../../mixin'

export default {
    name: 'Navigation',
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    mixins: [globalFunctions],
    data: () => {
        return ({
            items: [
                {
                    icon: 'home',
                    text: 'Dashboard',
                    route: '/dashboard',
                    section: 'Dashboard',
                    admin: false
                },
                {
                    icon: 'folder_open',
                    text: 'Progetti',
                    route: '/projects',
                    section: 'Projects',
                    admin: false
                },
                {
                    icon: 'menu_book',
                    text: 'Librerie',
                    route: '/libraries',
                    section: 'Libraries',
                    admin: false
                },
                {
                    icon: 'translate',
                    text: 'Lingue',
                    route: '/languages',
                    section: 'Languages',
                    admin: false
                },
                {
                    icon: 'g_translate',
                    text: 'Traduzioni',
                    route: '/translations',
                    section: 'Translations',
                    admin: false
                },

                {
                    icon: 'people_outline',
                    text: 'Utenti',
                    route: '/users',
                    section: 'Users',
                    admin: false
                },

                {
                    icon: 'description',
                    text: 'Categorie Cookie',
                    route: '/scripttypes',
                    section: 'ScriptTypes',
                    admin: false
                },
                {
                    icon: 'settings',
                    text: 'Settaggi',
                    route: '/settings',
                    section: 'Settings',
                    admin: false
                },
                {
                    icon: 'grade',
                    text: 'Ruoli',
                    route: '/roles',
                    section: 'Roles',
                    admin: false
                },
                {
                    icon: 'bug_report',
                    text: 'Debug',
                    route: '/debug',
                    section: 'Debug',
                    admin: true
                }

            ],
            debugCountRequested: false
        });
    },
    computed: {
        ...mapGetters(['isAuthenticated', 'miniVariant', 'privilegies', 'isSuperAdmin', 'debugFailedCount']),
    },
    watch: {
        isSuperAdmin() {
            this.loadDebugFailedCount()
        },
        privilegies() {
            this.loadDebugFailedCount()
        },
    },
    mounted() {
        this.loadDebugFailedCount()
    },
    methods: {
        loadDebugFailedCount() {
            if (!this.hasPermission('Debug') || this.debugCountRequested) return
            this.debugCountRequested = true
            this.$store.dispatch('loadDebugFailedCount')
        },
        logout () {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.replace("/login")
                })
        },
        hasPermission(text) {
            if(this.isSuperAdmin || text==="Dashboard"){
                return true
            }
            const privilegies = this.privilegies; // Assicurati che sia definito e oggetto

            if (!privilegies || typeof privilegies !== 'object') {
                return false;
            }
            return Object.prototype.hasOwnProperty.call(privilegies, text);
        },
        changeRoute (route){
            if(route!=''){
                this.$router.replace(route);
                this.$emit('close')
            }
        },
        checkVisible ( isAdminItem ) {
            return globalFunctions.checkVisible(isAdminItem);
        },
        isSelected(route) {
            return this.$route.path.startsWith(route);
        },
        handleClick(route) {
            this.changeRoute(route)
             // chiude su mobile
        }
    },
}
</script>

<style scoped>
.debug-count-badge {
    font-size: 0.75em;
    margin-left: 4px;
    opacity: 0.85;
    vertical-align: baseline;
}
</style>


